<template>
    <div class="ribbon ribbon-top ribbon-bookmark" :class="cardDeclined ? 'ribbon-red' : ''">
        <svg
            class="icon icon-filled"
            width="24"
            height="24"
            xmlns="http://www.w3.org/2000/svg"
        >
            <use xlink:href="#ribbon"></use>
        </svg>
    </div>
</template>
<script>
export default {
    props: {
        cardDeclined: {
            type: Boolean,
            default: false
        }
    },
}
</script>
